import Menu from './Compartido/Menu.jsx';
import CabeceraDestino from './Destino/CabeceraDestino.jsx';
import Rutas from './Destino/Rutas.jsx';
import OtrosDestinos from './Destino/OtrosDestinos.jsx';
import Footer from './Compartido/Footer.jsx';
import Scripts from './Compartido/Scripts.jsx';

const Destino = (props) => {
    var iddestino = props.eldestino.id;
    const ids_destinos = [32, 36, 40, 43, 44, 47, 48];
    if (!ids_destinos.includes(iddestino)) {
        iddestino = 36;
    }

    return (
        <main>
            <Scripts />
            <Menu
                lang={props.lang}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
                config={props.websgrupo}
                pagina={"destino_" + iddestino}
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
            />
            <CabeceraDestino
                lang={props.lang}
                destino={props.eldestino}
                ruta={props.ruta}
            />
            <Rutas
                lang={props.lang}
                rutasdestino={props.rutasdestino}
                ruta={props.ruta}
                destino={props.eldestino}
                propiedadesdestino={props.propiedadesdestino}
            />
            <OtrosDestinos
                lang={props.lang}
                destinos={props.destinos}
                ruta={props.ruta}
                destino={props.eldestino}
            />
            <Footer
                lang={props.lang}
                datos={props.websgrupo}
            />
        </main>
    )
}
export default Destino;

